var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "korean-hangeul-story" }, [
    _vm.activeIndex === 0
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hangeul_1_title")),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hangeul_1_text")),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "256",
                viewBox: "0 0 272 256",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M62 107C57.5817 107 54 110.582 54 115V174C54 178.418 57.5817 182 62 182H170",
                  stroke: "#AC6ED1",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M88 95H75C70.5817 95 67 98.5817 67 103V162C67 166.418 70.5817 170 75 170H207.875M96 95H220C224.418 95 228 98.5817 228 103V151.25",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M232 152C232 154.209 230.209 156 228 156C225.791 156 224 154.209 224 152C224 149.791 225.791 148 228 148C230.209 148 232 149.791 232 152Z",
                  fill: "#2C3143",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M100 114C100 116.209 98.2091 118 96 118H85C82.7909 118 81 116.209 81 114V112C81 109.791 82.7909 108 85 108H96C98.2091 108 100 109.791 100 112V114Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M100 133C100 135.209 98.2091 137 96 137H85C82.7909 137 81 135.209 81 133V132C81 129.791 82.7909 128 85 128H96C98.2091 128 100 129.791 100 132V133Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M100 152C100 154.209 98.2091 156 96 156H85C82.7909 156 81 154.209 81 152V151C81 148.791 82.7909 147 85 147H96C98.2091 147 100 148.791 100 151V152Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M129 114C129 116.209 127.209 118 125 118H113C110.791 118 109 116.209 109 114V112C109 109.791 110.791 108 113 108H125C127.209 108 129 109.791 129 112V114Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M129 133C129 135.209 127.209 137 125 137H113C110.791 137 109 135.209 109 133V132C109 129.791 110.791 128 113 128H125C127.209 128 129 129.791 129 132V133Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M166 147H113C110.791 147 109 148.791 109 151V152C109 154.209 110.791 156 113 156H181C183.209 156 185 154.209 185 152V151C185 148.791 183.209 147 181 147H175.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M156 114C156 116.209 154.209 118 152 118H142C139.791 118 138 116.209 138 114V112C138 109.791 139.791 108 142 108H152C154.209 108 156 109.791 156 112V114Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M156 133C156 135.209 154.209 137 152 137H142C139.791 137 138 135.209 138 133V132C138 129.791 139.791 128 142 128H152C154.209 128 156 129.791 156 132V133Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M185 114C185 116.209 183.209 118 181 118H170C167.791 118 166 116.209 166 114V112C166 109.791 167.791 108 170 108H181C183.209 108 185 109.791 185 112V114Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M185 133C185 135.209 183.209 137 181 137H170C167.791 137 166 135.209 166 133V132C166 129.791 167.791 128 170 128H181C183.209 128 185 129.791 185 132V133Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M214 114C214 116.209 212.209 118 210 118H199C196.791 118 195 116.209 195 114V112C195 109.791 196.791 108 199 108H210C212.209 108 214 109.791 214 112V114Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M214 133C214 135.209 212.209 137 210 137H199C196.791 137 195 135.209 195 133V132C195 129.791 196.791 128 199 128H210C212.209 128 214 129.791 214 132V133Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M214 152C214 154.209 212.209 156 210 156H199C196.791 156 195 154.209 195 152V151C195 148.791 196.791 147 199 147H210C212.209 147 214 148.791 214 151V152Z",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M79 51C72.3726 51 67 56.3829 67 63.0229V87.0688C67 93.7089 72.3726 99.0917 79 99.0917H82.1111L89.2517 111.969C90.0137 113.344 91.9863 113.344 92.7483 111.969L99.8889 99.0917H103C109.627 99.0917 115 93.7089 115 87.0688V63.0229C115 56.3829 109.627 51 103 51H79Z",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M101 82L82 82V69",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M165 38C158.373 38 153 43.3829 153 50.0229V74.0688C153 80.7089 158.373 86.0917 165 86.0917H168.111L175.252 98.9693C176.014 100.344 177.986 100.344 178.748 98.9693L185.889 86.0917H197C203.627 86.0917 209 80.7089 209 74.0688V50.0229C209 43.3829 203.627 38 197 38H165Z",
                  fill: "#8EA3EE",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M185 61L180 61",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M180 53V73",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M136 224.523C142.627 224.523 148 219.14 148 212.5L148 191.931C148 185.291 142.627 179.908 136 179.908H132.889L125.748 167.031C124.986 165.656 123.014 165.656 122.252 167.031L115.111 179.908L104 179.908C97.3726 179.908 92 185.291 92 191.931L92 212.5C92 219.14 97.3726 224.523 104 224.523L136 224.523Z",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M122 200L117 200",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M122 206L117 206",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M117 193V213",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M26 164C26 170.627 31.3829 176 38.0229 176H62.0688C68.7089 176 74.0917 170.627 74.0917 164V160.889L86.9693 153.748C88.3436 152.986 88.3436 151.014 86.9693 150.252L74.0917 143.111V140C74.0917 133.373 68.7089 128 62.0688 128L38.0229 128C31.3828 128 26 133.373 26 140L26 164Z",
                  fill: "#8EA3EE",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M60 146H41V159H60",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M213.889 156.908L206.748 144.031C205.986 142.656 204.014 142.656 203.252 144.031L196.111 156.908H193C186.373 156.908 181 162.291 181 168.931V192.977C181 199.617 186.373 205 193 205H217C223.627 205 229 199.617 229 192.977V168.931C229 162.291 223.627 156.908 217 156.908H213.889Z",
                  fill: "#8EA3EE",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M212 186C206.4 184.8 205 177.5 205 174C205 177.5 203 185 198 186",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
        ])
      : _vm.activeIndex === 1
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hangeul_2_title")),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hangeul_2_text")),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "256",
                viewBox: "0 0 272 256",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M83.0431 39.6001C83.0005 39.535 82.9503 39.3987 82.9527 39.1761C82.9537 39.0867 82.9618 39.0027 82.9762 38.9229C83.0967 38.2593 83.9087 38.0709 84.5719 38.1931C85.0647 38.2839 85.6232 38.3895 86 38.469C89.969 39.3054 93.6309 40.5209 96.8663 42.0379C98.6491 42.8738 99.3113 45.2371 98.3483 47.3466C96.4454 51.5153 95.0137 56.3214 94.1783 61.5352C93.9661 62.8598 94.9988 63.7402 95.8101 64.1093C96.6459 64.4896 97.8705 64.6452 98.8079 64.0119C100.459 62.8967 102.438 62.248 104.568 62.248C110.314 62.248 115 66.9873 115 72.8679C115 78.7485 110.314 83.4878 104.568 83.4878C102.536 83.4878 100.642 82.8975 99.0387 81.8753C98.0823 81.2655 96.8543 81.4573 96.025 81.859C95.222 82.248 94.1977 83.1546 94.4405 84.4787C94.9958 87.5063 95.7726 90.5189 96.8189 93.4322C97.3563 94.9286 97.1247 96.5934 96.3503 97.8834C95.5802 99.1661 94.3284 100 92.8555 100H49.8136C47.7227 100 46 98.2729 46 96.1077V46.1786C46 44.8083 46.687 43.5805 47.7976 42.987C51.2834 41.1242 55.356 39.6319 59.8379 38.6259C59.9921 38.5913 60.1873 38.5495 60.3923 38.5066C61.1573 38.3464 62.2204 38.6254 62.2456 39.4066C62.2527 39.629 62.2055 39.7666 62.1641 39.833C61.9557 40.1676 61.7622 40.5128 61.5849 40.8677C60.7281 42.5817 60.2458 44.5204 60.2458 46.5707C60.2458 53.5251 65.7966 59.1906 72.678 59.1906C79.5594 59.1906 85.1102 53.5251 85.1102 46.5707C85.1102 43.9965 84.3498 41.5986 83.0431 39.6001Z",
                  fill: "#AC6ED1",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M62 68H78V82",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M120.248 40.5932C120.248 34.7449 125 30 130.868 30C136.735 30 141.487 34.7449 141.487 40.5932C141.487 42.6594 140.895 44.5848 139.872 46.2131C139.268 47.1738 139.456 48.4082 139.856 49.2453C140.241 50.0507 141.147 51.0969 142.481 50.8488C145.976 50.1988 149.442 49.3745 152.817 48.2232C154.959 47.4924 157.289 48.3721 158.175 50.2938C158.744 51.5288 159.274 52.7246 159.564 53.4935C160.122 54.9702 160.609 56.4718 161.028 58C161.452 59.5471 161.545 61.3154 162.21 62.7823C162.535 63.4998 163.11 64.0317 164.053 64.2996C164.799 64.5114 165.773 64.5346 166.552 64.0156C168.229 62.8987 170.241 62.248 172.407 62.248C178.255 62.248 183 67.0006 183 72.868C183 78.7353 178.255 83.4879 172.407 83.4879C170.341 83.4879 168.415 82.8958 166.787 81.872C166.218 81.5141 165.555 81.4439 164.984 81.5054C164.406 81.5678 163.825 81.7738 163.341 82.0879C162.717 82.4934 162.404 83.0719 162.229 83.5874C162.188 83.7075 162.153 83.832 162.122 83.9562C161.928 84.7284 161.818 85.5244 161.65 86.3029C161.195 88.4189 160.623 90.5131 159.935 92.5814C159.804 92.9737 159.669 93.3652 159.53 93.7555C159.433 94.0277 159.07 95.0471 158.599 96.1289C158.363 96.6704 158.106 97.2137 157.847 97.6799C157.58 98.163 157.347 98.4968 157.173 98.6707C156.413 99.4308 155.171 100 154.107 100H104.178C102.815 100 101.586 99.3072 100.989 98.1748C99.0087 94.4162 97.4467 89.9853 96.4425 85.0982C96.3296 84.5488 96.1017 83.9648 96.7324 83.6663C96.9497 83.5635 97.1909 83.5045 97.4067 83.4975C97.6266 83.4903 97.762 83.5375 97.8274 83.5788C99.7787 84.8118 102.093 85.5254 104.57 85.5254C111.538 85.5254 117.19 79.8894 117.19 72.9322C117.19 65.975 111.538 60.339 104.57 60.339C101.993 60.339 99.5933 61.111 97.5944 62.4364C97.5302 62.479 97.396 62.5292 97.1759 62.5268C96.96 62.5244 96.7174 62.4707 96.4976 62.3726C95.9649 62.1347 96.2148 60.7138 96.2148 60.7138C96.2148 60.7138 96.3691 59.9015 96.452 59.5C97.2894 55.4413 98.5116 51.6974 100.04 48.3924C100.88 46.5761 103.241 45.9128 105.341 46.8853C109.511 48.8153 114.318 50.2674 119.533 51.1148C120.867 51.3316 121.746 50.277 122.111 49.4637C122.49 48.6203 122.643 47.3895 122.015 46.4475C121.446 45.5924 120.997 44.6502 120.695 43.6449C120.404 42.6789 120.248 41.6546 120.248 40.5932Z",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M138 81L138 69",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M127 81H149",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M165.442 83.0431C165.377 83.0005 165.24 82.9503 165.018 82.9527C164.929 82.9537 164.844 82.9618 164.765 82.9762C164.101 83.0967 163.913 83.9087 164.035 84.5719C164.126 85.0647 164.231 85.6232 164.311 86C165.147 89.969 166.363 93.6309 167.88 96.8663C168.716 98.6491 171.079 99.3113 173.188 98.3483C177.357 96.4454 182.163 95.0137 187.377 94.1783C188.702 93.9661 189.582 94.9988 189.951 95.8101C190.331 96.6459 190.487 97.8705 189.854 98.8079C188.738 100.459 188.09 102.438 188.09 104.568C188.09 110.314 192.829 115 198.71 115C204.59 115 209.33 110.314 209.33 104.568C209.33 102.536 208.739 100.642 207.717 99.0387C207.107 98.0823 207.299 96.8543 207.701 96.025C208.09 95.222 208.996 94.1977 210.32 94.4405C213.348 94.9958 216.519 95.7726 219.432 96.8189C220.928 97.3563 222.593 97.1247 223.883 96.3503C225.166 95.5802 226 94.3284 226 92.8555L226 49.8136C226 47.7227 224.273 46 222.107 46L172.02 46C170.65 46 169.422 46.687 168.829 47.7976C166.966 51.2834 165.474 55.356 164.468 59.8379C164.433 59.9921 164.391 60.1873 164.348 60.3923C164.188 61.1573 164.467 62.2204 165.248 62.2456C165.471 62.2527 165.608 62.2055 165.675 62.1641C166.009 61.9557 166.355 61.7622 166.709 61.5849C168.424 60.7281 170.362 60.2458 172.413 60.2458C179.367 60.2458 185.032 65.7966 185.032 72.678C185.032 79.5594 179.367 85.1102 172.413 85.1102C169.838 85.1102 167.44 84.3498 165.442 83.0431Z",
                  fill: "#8EA3EE",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M195 68V67H194V68H195ZM212 68H213C213 67.4477 212.552 67 212 67V68ZM212 82V83H213V82H212ZM195 82H194C194 82.5523 194.448 83 195 83V82ZM195 69H212V67H195V69ZM211 68V82H213V68H211ZM212 81H195V83H212V81ZM196 82V68H194V82H196Z",
                  fill: "#2C3143",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M147 209V217.167C147 222.597 142.597 227 137.167 227H97.8333C92.4025 227 88 222.597 88 217.167V177.833C88 172.403 92.4025 168 97.8333 168",
                  stroke: "#AC6ED1",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M165 179.5V199.167C165 204.597 160.597 209 155.167 209H115.833C110.403 209 106 204.597 106 199.167V194.333V159.833C106 154.403 110.403 150 115.833 150H155.167C160.597 150 165 154.403 165 159.833V165",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M129 171H142C142.333 171.833 142.6 174.2 141 177",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M127 180H145",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M135 180V176",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M130 184V183H129V184H130ZM142 184H143C143 183.448 142.552 183 142 183V184ZM142 190V191H143V190H142ZM130 190H129C129 190.552 129.448 191 130 191V190ZM130 185H142V183H130V185ZM141 184V190H143V184H141ZM142 189H130V191H142V189ZM131 190V184H129V190H131Z",
                  fill: "#2C3143",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M158 138L158 125",
                  stroke: "#AC6ED1",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M178 156L190 156",
                  stroke: "#AC6ED1",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M172 143L184 131",
                  stroke: "#AC6ED1",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
        ])
      : _vm.activeIndex === 2
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hangeul_3_title")),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hangeul_3_text")),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "256",
                viewBox: "0 0 272 256",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M19.0001 151.383C19.0001 125.214 40.214 104 66.3828 104C67.4283 104 70.0005 104 70.0005 104L82.0005 122L70.0005 131L69.9998 146L51.9998 158L69.9998 170V185H33.9998C25.2099 176.403 19.0001 164.651 19.0001 151.383Z",
                  fill: "#8EA3EE",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M70 104L82 122L70 131V146L52 158L70 170V185H34",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M95.4998 173L84.9998 170",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M84.9998 146L95.4998 143",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M103 158H82",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M43 119C43 119.518 43.0656 120.021 43.189 120.5C43.326 121.032 43.5341 121.536 43.8027 122C44.8401 123.793 46.7792 125 49 125C51.2208 125 53.1599 123.793 54.1973 122C54.4659 121.536 54.674 121.032 54.811 120.5C54.9344 120.021 55 119.518 55 119",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M124 72C115.163 72 108 79.1634 108 88V112C108 120.501 114.629 127.453 123 127.969V141.343C123 144.907 127.309 146.691 129.828 144.172L146 128H230C238.837 128 246 120.837 246 112V88C246 79.1634 238.837 72 230 72H124Z",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M130 148.013C130 151.558 134.326 153.334 136.856 150.827L153 135H237C245.872 135 253.065 127.873 253.065 119.081V95.2018C253.065 91.4424 251.75 87.9874 249.551 85.2638",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M189 106C192.795 102.837 193 98.0722 193 92C193 95.5 193.205 101.837 197 105",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M198 100L201 100",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M201 92V110",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M205 92V111",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M183 92V111",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M186 101L183 101",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M129 106V110H142",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M141 92V105",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M145 98L141 98",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: {
                  cx: "131",
                  cy: "97",
                  r: "4",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M168 95L178 95",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M173 95L173 91",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: {
                  cx: "173",
                  cy: "102",
                  r: "4",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M149 93V101H157",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "156.5",
                  cy: "108",
                  rx: "5.5",
                  ry: "3",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M157 93H162",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M157 97H162",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M162 91V102",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M211 108H227",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M216 108L216 102",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M222 108V102",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "219",
                  cy: "97.5",
                  rx: "7",
                  ry: "4.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c("v-button", {
                attrs: {
                  i18n: { id: "onboarding_experience_start_btn" },
                  filled: true,
                  color: "primary",
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.startLearning.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }